import { render, staticRenderFns } from "./WorkShow.vue?vue&type=template&id=eb6a1f1c&scoped=true&"
import script from "./WorkShow.vue?vue&type=script&lang=js&"
export * from "./WorkShow.vue?vue&type=script&lang=js&"
import style0 from "./WorkShow.vue?vue&type=style&index=0&id=eb6a1f1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6a1f1c",
  null
  
)

export default component.exports